<template>
  <HScaffold title="VIP详情">
    <div v-if="vipDetailData!=null" class="tVipDetailParentDiv" :style="{
      backgroundColor: HNewGameUIConfig.newGameUIType === 3?'#1f1f1f':'white',
    }">
      <img :src="iconPVipTextArray[user.vipLevel]" :style="{
        height:'15px',
        width:260/42*15+'px',
        filter: HNewGameUIConfig.newGameUIType === 3?'brightness(0) invert(1)':'',
        marginTop: '15px',marginLeft: '10px',marginBottom: '10px',
      }" alt="">
      <div style="background-color: var(--ct-main-bg-color)">
        <HTable
            :targetRowIndex="user.vipLevel"
            targetRowIndexColor="#E0890033"
            :headerColor="hcf.getMainColor()"
            :isDataSameColor="true"
            :isShowBorder="true"
            :tabData='{
                  "header":[
                              "VIP等级",
                              {
                                "VIP详情": ["晋级流水", "保级流水", "晋级礼金"]
                              },
                              {
                                "周专属红包详情": ["有效流水", "周工资"]
                              }
                            ],
                "list": vipDetailData["VipPrivilege"]
            }'
        />
      </div>
      <div :style="hcf.getTextStyle({
          addSize:1,fontWeight:'bold',color: 'main',marginLeft:10,marginTop:20,
      })">说明
      </div>
      <div v-for="eachRemark in vipDetailData['VipPrivilegeRule']" :key="eachRemark">
        <div :style="hcf.getTextStyle({
            marginLeft:10,addSize:-1,
        })">
          {{eachRemark}}
        </div>
      </div>
      <van-divider style="margin:10px"/>
      <img :src="iconVipRebateText" :style="{
        height:'15px',
        filter: HNewGameUIConfig.newGameUIType === 3?'brightness(0) invert(1)':'',
        width:231/42*15+'px',
        marginLeft: '10px',marginBottom: '10px',
      }" alt="">
      <div style="background-color: var(--ct-main-bg-color)">
        <HTable
            :targetRowIndex="user.vipLevel"
            targetRowIndexColor="#E0890033"
            :headerColor="hcf.getMainColor()"
            :isDataSameColor="true"
            :isShowBorder="true"
            :tabData='{
              "header":[
                "VIP等级",
                "电子",
                "棋牌",
                "真人",
                "捕鱼",
                "体育",
                "电竞"
              ],
              "list": vipDetailData["VipRebate"],
            }'
        />
      </div>
      <div :style="hcf.getTextStyle({
          addSize:1,fontWeight:'bold',color: 'main',marginLeft:10,marginTop:20,
      })">说明
      </div>
      <div v-for="eachRemark in vipDetailData['VipRebateRule']" :key="eachRemark">
        <div :style="hcf.getTextStyle({
            marginLeft:10,addSize:-1,fontWeight:'bold'
        })">
          {{eachRemark}}
        </div>
      </div>
      <van-divider style="margin:10px"/>
      <img :src="iconVipActivityRuleText" :style="{
        filter: HNewGameUIConfig.newGameUIType === 3?'brightness(0) invert(1)':'',
        height:'15px',
        width:417/42*15+'px',
        marginLeft: '10px',marginBottom: '10px',
      }" alt="">
      <div style="padding:0 10px;margin-bottom:10px;flex-direction: column;" v-for="eachRule in vipDetailData['ActivityRule']" :key="eachRule['Title']">
        <div style="border-radius: 6px;display: inline-flex;padding: 2px 5px;background-color: var(--ct-main-color)">
          <div :style="hcf.getTextStyle({
                color:HNewGameUIConfig.newGameUIType === 3?'#000':'white',addSize:-1
          })">
            {{eachRule["Title"]}}
          </div>
        </div>
        <div :style="hcf.getTextStyle({
                addSize:-1
          })">
          {{eachRule["Desc"]}}
        </div>
      </div>
      <van-divider style="margin:0"/>
      <div :style="hcf.getTextStyle({
          addSize:1,fontWeight:'bold',color: 'main',marginLeft:10,marginTop:20,
      })">最终解释
      </div>
      <div v-for="eachRule in vipDetailData['PlatRule']" :key="eachRule">
        <div :style="hcf.getTextStyle({
            marginLeft:10,addSize:-1,fontWeight:'bold'
        })">
          {{eachRule}}
        </div>
      </div>
    </div>
  </HScaffold>
</template>


<script setup>
  import HScaffold from "@/components/utils/HScaffold.vue";
  import {useUserStore} from "@/stores/useUser.js";
  import {useHHttp} from "@/hooks/useHHttp.js";
  import {showToast} from "vant";
  import HTable from "@/components/utils/HTable.vue";
  import {hcf} from "@/components/utils/HComFunctions.js";
  import iconPVipText0 from "@/assets/icons/vip/vip_privilege_text_0.png"
  import iconPVipText1 from "@/assets/icons/vip/vip_privilege_text_1.png"
  import iconPVipText2 from "@/assets/icons/vip/vip_privilege_text_2.png"
  import iconPVipText3 from "@/assets/icons/vip/vip_privilege_text_3.png"
  import iconPVipText4 from "@/assets/icons/vip/vip_privilege_text_4.png"
  import iconPVipText5 from "@/assets/icons/vip/vip_privilege_text_5.png"
  import iconPVipText6 from "@/assets/icons/vip/vip_privilege_text_6.png"
  import iconPVipText7 from "@/assets/icons/vip/vip_privilege_text_7.png"
  import iconPVipText8 from "@/assets/icons/vip/vip_privilege_text_8.png"
  import iconPVipText9 from "@/assets/icons/vip/vip_privilege_text_9.png"
  import iconPVipText10 from "@/assets/icons/vip/vip_privilege_text_10.png"
  import iconVipRebateText from "@/assets/icons/vip/vip_rebate_text.png"
  import iconVipActivityRuleText from "@/assets/icons/vip/vip_activity_rule_text.png"
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";
  const iconPVipTextArray = [iconPVipText0, iconPVipText1, iconPVipText2, iconPVipText3, iconPVipText4, iconPVipText5,
    iconPVipText6, iconPVipText7, iconPVipText8, iconPVipText9, iconPVipText10];
  const user = useUserStore();
  const http = useHHttp();
  const vipDetailData = ref(null);

  onMounted(() => {
    http.request("/app/active/vip/cfg", (data) => {
      vipDetailData.value = data;
    }, {
      errCallBack: (resp) => {
        if (resp != null || resp["m"]) {
          showToast(resp["m"] ?? '');
        }
      }
    });
  });

</script>


<style scoped>

  .tVipDetailParentDiv {
    display: flex;
    flex-direction: column;
    padding-bottom: 20px;
  }

</style>
